export class AppSettings {
    public static ERROR_MSG = 'We are unable to reach the server. Please try again in sometime';
    public static API_ENDPOINT = '';
}